import { t } from 'i18next'
import generalErrorPage from '@app/assets/img/generalErrorPage.svg'

import GlobalError from './GlobalError'

const GlobalErrorPage = ({ resetError }: { resetError: () => void }) => {
  return (
    <GlobalError
      title={t('error.somethingWentWrong')}
      description={t('error.tryGoingBackToHome')}
      resetError={resetError}
      imgData={{ src: generalErrorPage, alt: 'General Error Page' }}
    />
  )
}

export default GlobalErrorPage
